import { NgModule } from '@angular/core';
import { ErrorStateMatcher, MAT_DATE_LOCALE, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import {
  MAT_PAGINATOR_DEFAULT_OPTIONS,
  // MatPaginatorIntl
} from '@angular/material/paginator';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from '../../environments/environment';

@NgModule({
  providers: [
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: environment.locale,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: environment.dialogOptions,
    },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: environment.pageOptions,
    },
    /* {
    provide: MatPaginatorIntl,
    useClass: CustomMatPaginatorIntl,
  }, */
  ],
})
export class MaterialModule {
  constructor(private domSanitizer: DomSanitizer, private matIconRegistry: MatIconRegistry) {
    this.addCustomIcons();
  }

  private addCustomIcons(...iconList: string[]) {
    iconList.forEach(iconName =>
      // Adding icon to registry
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/icons/${iconName}.svg`)
      )
    );
  }
}
